import React from 'react';

import Text from '~/components/core/TextComponents/Text';

import TEXTS from './texts';

const IncomeProtectionFieldDisplay = ({ label, valueDisplay }: { label: string; valueDisplay: React.ReactNode }) => {
  return (
    <div className="grid gap-4 text-nowrap">
      <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.SEMI_BOLD} className="text-slate-800">
        {label}
      </Text>
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
        {valueDisplay ?? TEXTS.emptyValue}
      </Text>
    </div>
  );
};

export default IncomeProtectionFieldDisplay;
